<template>
  <Modal
    v-model:visible="showModal"
    :header="title"
    :closable="true"
    append-to="self"
    @hide="close"
  >
    <form-row
      v-if="apiErrorCode !== 'unauthorized'"
      type="container"
      no-inputs="no-inputs"
    >
      <p class="bold">
        {{ $t('components.popupApiError.serverIsUnreachable') }}
      </p>
      <div>
        {{ $t('components.popupApiError.email')
        }}<a href="mailto:support@clear.co">&nbsp;support@clear.co</a>
      </div>
      <div>
        {{ $t('components.popupApiError.phone')
        }}<a :href="`tel:${contactDetails.number}`"
          >&nbsp;{{ contactDetails.number }}</a
        >
      </div>
    </form-row>
    <div
      v-else
      :class="$style['body-container']"
      type="container"
      no-inputs="no-inputs"
    >
      <p :class="$style['body-paragraph']">
        {{ $t('components.popupApiError.toKeepYourAccountSecure') }}
      </p>
      <p :class="$style['body-paragraph']">
        {{ $t('components.popupApiError.pleaseLoginToContinue') }}
      </p>
      <OnboardingButton
        :class="$style['login-cta']"
        :text="$t('common.buttons.logIn')"
        @click="close"
      />
    </div>
  </Modal>
</template>

<script>
import { mapGetters } from 'vuex';
import analytics, { SEGMENT_EVENTS } from '@/utils/analytics';
import OnboardingButton from '@/components/buttons/OnboardingButton.vue';
import Modal from '@/components/shared/Dialog.vue';
import { RouteNames } from '@/data/routes';

export default {
  components: {
    Modal,
    OnboardingButton,
  },
  data() {
    return {
      showModal: false,
    };
  },
  computed: {
    ...mapGetters(['apiErrorCode', 'contactDetails']),
    title() {
      const unauthorized = this.$t('components.popupApiError.sessionExpired');
      const timeout = this.$t('components.popupApiError.requestTimeout');
      const internalServerError = this.$t(
        'components.popupApiError.internalServerError',
      );
      const gatewayTimeout = this.$t('components.popupApiError.gatewayTimeout');
      return (
        {
          unauthorized,
          timeout,
          500: internalServerError,
          504: gatewayTimeout,
        }[this.apiErrorCode] || internalServerError
      );
    },
    currentRoute() {
      return this.$route.name;
    },
  },
  mounted() {
    if (this.apiErrorCode === 'unauthorized') {
      analytics.track(SEGMENT_EVENTS.viewed_session_expired, {
        stage: this.currentRoute,
        timestamp: new Date(),
      });
    }
  },
  watch: {
    apiErrorCode() {
      this.showModal = !!this.apiErrorCode;
    },
  },
  methods: {
    close() {
      if (this.apiErrorCode) {
        if (
          this.apiErrorCode === 'unauthorized' ||
          this.apiErrorCode === 'timeout'
        ) {
          this.$router.push({
            name: RouteNames.AUTH.LOGOUT,
          });
        }
        this.$store.commit('HIDE_API_ERROR_POPUP');
      }
    },
  },
};
</script>

<style lang="less" module>
.body-container {
  margin: auto;
  padding-bottom: 30px;
  @media only screen and (min-width: 501px) {
    width: 90%;
  }
  .body-paragraph {
    text-align: left;
    font-weight: 400;
    color: black;
    font-family: @regular-font;
    margin: 0 0 2em;
    top: 0;
  }
  .login-cta {
    margin-top: 50px;
  }
}
</style>
